import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { CampaignStructureLevel } from '../../api/models';

@Injectable({ providedIn: 'root' })
export class LevelTabService {
    static levelTabChange$ = new Subject<CampaignStructureLevel>();
    constructor() { }
}
